import React from 'react';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom'

const PrimaryStyledPrimaryButton = styled(NavLink)`
  display: flex;
  line-height: 56px;
  color: #FFF;
  background-color: #00A651;
  font-size: 1rem;
  height: 56px;
  padding-left: 30px;
  padding-right: 30px;
  border-radius: 6px;
  border: 1px solid transparent;
  font-weight: 500;
  box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.19);
  cursor: pointer;
  min-width: 100px;
  justify-content: center;
  
  &:hover {
    opacity: 0.9;
  }
  &:visited, &:link {
   color: #FFF;
  } 
}

  
  ${props => props.styles }
`;


const PrimaryButton = (props) => (
    <PrimaryStyledPrimaryButton to={props.to} {...props}>{props.children}</PrimaryStyledPrimaryButton>);

export default PrimaryButton;


// WEBPACK FOOTER //
// ./src/Components/PrimaryButton.js